import API from 'services/API';

export function searchExistingCheck(data) {
  return API.request({
    method: 'POST',
    url: `/receipts/search`,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    data,
  });
}
export function saveCheck(data) {
  return API.request({
    method: 'POST',
    url: `/receipts`,
    data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
}
